/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Execute_Detail7Inputs */

const en_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build with real tool calls, not mocked ones, and test edge cases.`)
};

const ar_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابنِ باستدعاءات أدوات حقيقية, لا مُحاكاة, واختبر الحالات الحدية.`)
};

const bn_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মক করা নয়, আসল টুল কল দিয়ে বিল্ড করুন এবং এজ কেস টেস্ট করুন।`)
};

const de_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie mit echten Toolaufrufen, nicht mit simulierten, und testen Sie Randfälle.`)
};

const es_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrolle con llamadas reales, no simuladas, y pruebe casos límite.`)
};

const fr_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construisez avec des appels d'outils réels, pas des appels simulés, et testez des cas extrêmes.`)
};

const pt_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie com chamadas de ferramentas reais, não simuladas, e teste casos extremos.`)
};

const zh_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用真实的工具调用（而不是 mock 的）开发，并测试边界情况。`)
};

const tr_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mock'larla değil, gerçek araç çağrılarıyla geliştirin, uç durumları test edin.`)
};

const ru_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создавайте на реальных вызовах инструментов, а не моках, и тестируйте краевые случаи.`)
};

const pl_svc_ai_agent_development_execute_detail7 = /** @type {(inputs: Svc_Ai_Agent_Development_Execute_Detail7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twórz na prawdziwych wywołaniach narzędzi, nie mockowanych, i testuj edge case'y.`)
};

/**
* | output |
* | --- |
* | "Build with real tool calls, not mocked ones, and test edge cases." |
*
* @param {Svc_Ai_Agent_Development_Execute_Detail7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_execute_detail7 = /** @type {((inputs?: Svc_Ai_Agent_Development_Execute_Detail7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Execute_Detail7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "de") return de_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "es") return es_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_execute_detail7(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_execute_detail7(inputs)
	return en_svc_ai_agent_development_execute_detail7(inputs)
});
export { svc_ai_agent_development_execute_detail7 as "svc_ai-agent-development_EXECUTE_detail" }